 import React, { useState, useEffect } from "react"; 
 import axios from "axios"; import { Col, Row ,Dropdown} from 'react-bootstrap';
  import { Link, useNavigate } from "react-router-dom";

 const ENTRY_API = "https://subk.education.com.ly/back/api/journal-entries";
 const LINE_API = "https://subk.education.com.ly/back/api/journal-entry-lines";
 const ACCOUNT_API = "https://subk.education.com.ly/back/api/accounts";
function JournalEntryPage() {

    const navigate = useNavigate(); // Use useNavigate hook for navigation

 ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'JournalEntryPage';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [entries, setEntries] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [form, setForm] = useState({
    EntryDate: "",
    Description: "",
    lines: []
  });
  const [editingId, setEditingId] = useState(null);
 // New state for date filter
  const [filter, setFilter] = useState({
    startDate: "",
    endDate: "",
  });

  // Fetch entries with optional date filter
const fetchEntries = async () => {
  try {
    let res;

    // Only fetch filtered data if both dates are set
    if (filter.startDate && filter.endDate) {
      res = await axios.get(ENTRY_API, {
        params: {
          start_date: filter.startDate,
          end_date: filter.endDate,
        },
      });
       setEntries(res.data);
 } else {
    setEntries([]);
    }

  } catch (err) {
    console.error("Error fetching entries:", err);
  }
};

//   // const fetchEntries = async () => {
//   //   try {
//   //     const res = await axios.get(ENTRY_API);
//   //     const entriesWithLines = await Promise.all(
//   //       res.data.map(async entry => {
//   //         const linesRes = await axios.get(`${LINE_API}?EntryID=${entry.EntryID}`);
//   //         return { ...entry, lines: linesRes.data };
//   //       })
//   //     );
//   //     setEntries(entriesWithLines);
//   //   } catch (err) {
//   //     console.error(err);
//   //   }
//   // };
// const fetchEntries = async () => {
//   try {
//     // 1️⃣ Get all journal entries
//     const res = await axios.get(ENTRY_API); // ENTRY_API = "/api/journal-entries"

//     // 2️⃣ For each entry, fetch its lines
//     // const entriesWithLines = await Promise.all(
//     //   res.data.map(async (entry) => {
//     //     const linesRes = await axios.get(`${LINE_API}?EntryID=${entry.EntryID}`); // LINE_API = "/api/journal-entry-lines"
//     //     return {
//     //       ...entry,
//     //       lines: linesRes.data // add the lines array to the entry
//     //     };
//     //   })
//     // );

//     // 3️⃣ Update state so your table can render
//     setEntries(res.data);
//   } catch (err) {
//     console.error("Error fetching entries:", err);
//   }
// };

  const fetchAccounts = async () => {
    try {
      const res = await axios.get(ACCOUNT_API);
      setAccounts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchEntries();
    fetchAccounts();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLineChange = (index, e) => {
    const newLines = [...form.lines];
    newLines[index][e.target.name] = e.target.value;
    setForm({ ...form, lines: newLines });
  };

  const addLine = () => {
    setForm({ ...form, lines: [...form.lines, { AccountID: "", Debit: 0, Credit: 0 }] });
  };

  const removeLine = (index) => {
    const newLines = [...form.lines];
    newLines.splice(index, 1);
    setForm({ ...form, lines: newLines });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
      const totalDebit = form.lines.reduce((sum, l) => sum + Number(l.Debit || 0), 0);
  const totalCredit = form.lines.reduce((sum, l) => sum + Number(l.Credit || 0), 0);

  if (totalDebit !== totalCredit) {
    alert(`إجمالي المدين (${totalDebit}) لا يساوي إجمالي الدائن (${totalCredit})`);
    return; // stop submission
  }
    try {
      let entry;
      if (editingId) {
        entry = await axios.put(`${ENTRY_API}/${editingId}`, {
          EntryDate: form.EntryDate,
          Description: form.Description
        });
        const existingLines = entries.find(en => en.EntryID === editingId).lines;
        for (let l of existingLines) {
          await axios.delete(`${LINE_API}/${l.LineID}`);
        }
      } else {
        entry = await axios.post(ENTRY_API, {
          EntryDate: form.EntryDate,
          Description: form.Description
        });
      }

      for (let line of form.lines) {
        await axios.post(LINE_API, {
          EntryID: editingId || entry.data.EntryID,
          AccountID: line.AccountID,
          Debit: line.Debit,
          Credit: line.Credit
        });
      }
    setShowRegisterForm(false);

      setForm({ EntryDate: "", Description: "", lines: [] });
      setEditingId(null);
      fetchEntries();
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء حفظ القيد");
    }
  };

  const handleEdit = (entry) => {
        setShowRegisterForm(true);

    setForm({
      EntryDate: entry.EntryDate,
      Description: entry.Description,
      lines: entry.lines.map(l => ({
        AccountID: l.AccountID,
        Debit: l.Debit,
        Credit: l.Credit
      }))
    });
    setEditingId(entry.EntryID);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا القيد؟")) return;
    try {
      const entry = entries.find(e => e.EntryID === id);
      for (let l of entry.lines) {
        await axios.delete(`${LINE_API}/${l.LineID}`);
      }
      await axios.delete(`${ENTRY_API}/${id}`);
      fetchEntries();
    } catch (err) {
      console.error(err);
      alert("حدث خطأ أثناء حذف القيد");
    }
  };
    const handleSearch = () => {
    fetchEntries();
  };
 const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };
  // Clear filter
  const handleClear = () => {
    setFilter({ startDate: "", endDate: "" });
    fetchEntries();
  };
const handleCancel = () => {
  setForm({ EntryDate: "", Description: "", lines: [] });
      setShowRegisterForm(false);

  setEditingId(null);
};
  const [showRegisterForm, setShowRegisterForm] = useState(false);

  return (
     <div className='container-fluid'>
              <Row>
                <Col lg="12">
                  <div className="card p-3">
                  <div className="card-body p-0">
                      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
      
                       <div className="tbl-caption">
                       <h4 className="heading ms-3">القيود اليومية</h4>
                                    {!showRegisterForm && (
  
                        < Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                                                      onClick={() => setShowRegisterForm(true)}
  > + إضافة قيد </Link>  
                                      
                                  )}
                              </div>  
                              </div>   </div> 
                                                            {showRegisterForm && (
       <div>
      <form className="mb-4" onSubmit={handleSubmit}>
        <div className="row g-2 mb-2">
          <div className="col-md-3">
            <input
              type="date"
              name="EntryDate"
              className="form-control"
              value={form.EntryDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-9">
            <input
              type="text"
              name="Description"
              className="form-control"
              placeholder="الوصف"
              value={form.Description}
              onChange={handleChange}
            />
          </div>
        </div>

        {form.lines.map((line, idx) => (
          <div className="row g-2 mb-2" key={idx}>
            <div className="col-md-4">
              <select
                className="default-select form-control "
                name="AccountID"
                value={line.AccountID}
                onChange={(e) => handleLineChange(idx, e)}
                required
              >
                <option value="">--اختر الحساب--</option>
                {accounts.map(acc => (
                  <option key={acc.AccountID} value={acc.AccountID}>{acc.AccountName}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <input
                type="number"
                className="form-control"
                name="Debit"
                value={line.Debit}
                onChange={(e) => handleLineChange(idx, e)}
                placeholder="مدين"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                className="form-control"
                name="Credit"
                value={line.Credit}
                onChange={(e) => handleLineChange(idx, e)}
                placeholder="دائن"
              />
            </div>
            <div className="col-md-2">
              <button
                type="button"
                className="btn btn-danger "
                onClick={() => removeLine(idx)}
              >
                إزالة
              </button>
            </div>
          </div>
        ))}

       <div className="mb-2">
  <button type="button" className="btn btn-secondary mx-2" onClick={addLine}>
    إضافة سطر
  </button>

  <button type="submit" className="btn btn-primary mx-2">
    {editingId ? "تحديث القيد" : "إضافة قيد"}
  </button>

  {editingId ? (
    <button type="button" className="btn btn-danger mx-2" onClick={handleCancel}>
      إلغاء
    </button>
  ):(<button  className="btn btn-danger  "
                            onClick={() => setShowRegisterForm(false)}
>
           الغاء
          </button>


  )}
</div>
      </form>
           </div>                         
                                  )}
  <div className="mb-3 d-flex gap-2">
                <input
                  type="date"
                  name="startDate"
                  className="form-control"
                  value={filter.startDate}
                  onChange={handleFilterChange}
                  placeholder="من تاريخ"
                />
                <input
                  type="date"
                  name="endDate"
                  className="form-control"
                  value={filter.endDate}
                  onChange={handleFilterChange}
                  placeholder="إلى تاريخ"
                />
                <button className="btn btn-primary" onClick={handleSearch}>
                  بحث
                </button>
                <button className="btn btn-secondary" onClick={handleClear}>
                  مسح
                </button>
              </div>
                                  <table className="table table-bordered table-striped">
  <thead className="table-dark text-center">
    <tr>
      <th>الرقم</th>
      <th>المرجع</th>
      <th>التاريخ</th>
      <th>الوصف</th>
      
      <th>السطر</th>
     </tr>
  </thead>
  <tbody>
    {entries.length ? (
      entries.map(entry => (
        <tr key={entry.EntryID}>
          <td>{entry.EntryID}</td>
          <td style={{whiteSpace:'normal'}}>{entry.Reference || "-"}</td>
          <td >{entry.EntryDate}</td>
          <td style={{whiteSpace:'normal'}}>{entry.Description}</td>
          
          <td>
            <table className="table table-sm table-bordered mb-0 text-center">
              <thead className="table-light">
                <tr>
                  <th>الحساب</th>
                  <th>مدين</th>
                  <th>دائن</th>
                        <th>الوصف</th>

                </tr>
              </thead>
              <tbody>
                {entry.lines.map((line, idx) => {
                  const acc = accounts.find(a => a.AccountID === line.AccountID);
                  return (
                    <tr key={idx}>
                      <td>{acc ? acc.AccountName : line.AccountID}</td>
                      <td>{line.Debit}</td>
                      <td>{line.Credit}</td>
                                            <td style={{whiteSpace:'normal'}}>{line.Description}</td>

                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr className="fw-bold">
                  <td>المجموع</td>
                  <td>{entry.lines.reduce((sum, l) => sum + Number(l.Debit), 0)}</td>
                  <td>{entry.lines.reduce((sum, l) => sum + Number(l.Credit), 0)}</td>
                </tr>
              </tfoot>
            </table>
          </td>
          {/* <td className="text-center">
            <button
              className="btn btn-sm btn-warning mx-2"
              onClick={() => handleEdit(entry)}
            >
              تعديل
            </button>
            <button
              className="btn btn-sm btn-danger mx-2"
              onClick={() => handleDelete(entry.EntryID)}
            >
              حذف
            </button>
          </td> */}
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="9" className="text-center">لاتوجد بيانات لعرضها.</td>
      </tr>
    )}
  </tbody>
</table>

      {/* Journal Entries Table */}
      {/* <table className="table table-bordered table-striped">
        <thead className="table-dark text-center">
          <tr>
            <th>الرقم</th>
            <th>التاريخ</th>
            <th>الوصف</th>
            <th>السطر</th>
            <th>الإجراءات</th>
          </tr>
        </thead>
        <tbody>
          {entries.length ? (  
          
          entries.map(entry => (
            <tr key={entry.EntryID}>
              <td>{entry.EntryID}</td>
              <td>{entry.EntryDate}</td>
              <td>{entry.Description}</td>
              <td>
                <table className="table table-sm table-bordered mb-0 text-center">
                  <thead className="table-light">
                    <tr>
                      <th>الحساب</th>
                      <th>مدين</th>
                      <th>دائن</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entry.lines.map((line, idx) => {
                      const acc = accounts.find(a => a.AccountID === line.AccountID);
                      return (
                        <tr key={idx}>
                          <td>{acc ? acc.AccountName : line.AccountID}</td>
                          <td>{line.Debit}</td>
                          <td>{line.Credit}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="fw-bold">
                      <td>المجموع</td>
                      <td>{entry.lines.reduce((sum, l) => sum + Number(l.Debit), 0)}</td>
                      <td>{entry.lines.reduce((sum, l) => sum + Number(l.Credit), 0)}</td>
                    </tr>
                  </tfoot>
                </table>
              </td>
              <td className="text-center">
                <button
                  className="btn btn-sm btn-warning mx-2"
                  onClick={() => handleEdit(entry)}
                >
                  تعديل
                </button>
                <button
                  className="btn btn-sm btn-danger mx-2"
                  onClick={() => handleDelete(entry.EntryID)}
                >
                  حذف
                </button>
              </td>
            </tr>
          ))
          ):(

             
      <tr>
        <td colSpan="4">لاتوجد بيانات لعرضها.</td>
      </tr>
    )}
        </tbody>
      </table> */}
</div>
					</Col>
				</Row>
			</div>  );
}

export default JournalEntryPage;
// {/* 
//       <table className="table table-bordered table-striped">
//         <thead className="table-dark">
//           <tr>
//             <th>ID</th>
//             <th>Date</th>
//             <th>Description</th>
//             <th>Lines</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {entries.map(entry => (
//             <tr key={entry.EntryID}>
//               <td>{entry.EntryID}</td>
//               <td>{entry.EntryDate}</td>
//               <td>{entry.Description}</td>
//               <td>
//                 {entry.lines.map(l => `${l.AccountID} (D:${l.Debit} C:${l.Credit})`).join(", ")}
//               </td>
//               <td>
//                 <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(entry)}>
//                   Edit
//                 </button>
//                 <button className="btn btn-sm btn-danger" onClick={() => handleDelete(entry.EntryID)}>
//                   Delete
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table> */}
